import React from 'react'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { Spinner } from '@vwfs-bronson/bronson-react'
import { useNavigate } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { isDev } from './services/common/data'
import {
  setKeycloakIdp as setKeycloakIdpAction,
  setKeycloakIdpHint as setKeycloakIdpHintAction,
  getKeycloakIdp,
} from './services/redux/features/keycloak'
import { App } from './App'
import { qs } from './services/routing'
import keycloakClient from './services/api/login/keycloak'
import { generateTanInit } from './services/api/tan'
import {
  resetFormData as setTransactionId,
  setFormData,
} from './services/redux/features/form'
import { setAxiosIdToken, setAxiosToken } from './services/api'
import { mapBusModelToFrontendModel } from './services/data/mapping'
import { done } from './services/redux/features/dataStorage'

const Loading = () => (
  <div className="u-text-center u-m-xlarge">
    <Spinner center />
  </div>
)

export const MINUTES_TO_AUTO_LOGOUT = 10;

function KeycloakWrapper(props) {
  const brandName = process.env.REACT_APP_BRAND
  const navigate = useNavigate()
  const { keycloakIdp } = props
  const dispatch = useDispatch()

  const [keycloakId, setKeycloakId] = React.useState('')
  const keycloakLoginId = qs('loginId')
  const keycloakLogoutId = qs('logoutId')
  const keycloak = React.useMemo(() => {
    return keycloakIdp === 'vwfs'
      ? keycloakClient.vwfs.kc
      : keycloakClient[brandName].kc
  }, [keycloakIdp, brandName])
  React.useEffect(() => {
    if (keycloakLoginId && keycloak.authenticated) {
      setKeycloakId(keycloakLoginId)
    }
    if (keycloakLogoutId && !keycloak.authenticated) {
      setKeycloakId(keycloakLogoutId)
    }
  }, [keycloakLogoutId, keycloakLoginId, keycloak.authenticated])
  const [isKeycloakReady, setIsKeycloakReady] = React.useState(false)
  const [isReady, setIsReady] = React.useState(false)
  React.useEffect(() => {
    if (keycloakId) {
      dispatch(setTransactionId(keycloakId))
      generateTanInit(keycloakId)
        .then(response => {
          setAxiosIdToken(response.response.nonce)
          setAxiosToken(response.response.token)
          dispatch(done(response.data.data))
          dispatch(
            setFormData({
              ...mapBusModelToFrontendModel(response.data.data),
              transactionId: keycloakId,
            })
          )
          setIsReady(true)
          navigate({ search: '' }, { replace: true })
        })
        .catch(() => navigate('/error'))
    }
  }, [keycloakId, dispatch, navigate])

  React.useEffect(() => {
    setIsReady(!keycloakId)
  }, [keycloakId])

  const eventLogger = (event, error) => {
    if (isDev()) {
      // eslint-disable-next-line no-console
      console.log('onKeycloakEvent', event, error)
    }
    if (event === 'onReady' || event === 'onInitError') {
      setIsKeycloakReady(true)
    }
  }

  const tokenLogger = tokens => {
    if (isDev()) {
      // eslint-disable-next-line no-console
      console.log('onKeycloakTokens', tokens)
    }
  }

  const logout = () => {
    navigate({ search: '' }, { replace: true })
    const redirectUri =
      `${window.origin}/` === window.location.href
        ? window.origin
        : `${window.location.href}?logoutId=${keycloakId}`
    keycloak.logout({
      redirectUri,
    })
  }

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        checkLoginIframe: false,
      }}
      onEvent={eventLogger}
      onTokens={tokenLogger}
    >
      {isReady && isKeycloakReady ? (
        <App keycloak={keycloak} keycloakLogout={logout} />
      ) : (
        <Loading />
      )}
    </ReactKeycloakProvider>
  )
}

export default connect(
  state => ({
    keycloakIdp: getKeycloakIdp(state),
  }),
  dispatch => ({
    setKeycloakIdp: value => dispatch(setKeycloakIdpAction(value)),
    setKeycloakIdpHint: value => dispatch(setKeycloakIdpHintAction(value)),
  })
)(KeycloakWrapper)
